import React from "react";
import { Switch } from "react-router-dom";

import { isEmptyString } from "@/tools/format.checker";

import { ReactComponent as Logo } from "../../assets/icon/logo-large-primary.svg";
import WelcomeNewer from "../Feature/WelcomeNewer";

import { useUserProfileContext } from "@/context/UserProfileContext";
import Drawer from "./Drawer/Drawer";
import Router from "./Router";

const MainFlowApp: React.FC = () => {
  const { email } = useUserProfileContext();
  return (
    <main className="main">
      <WelcomeNewer />
      {!isEmptyString(email) && (
        <>
          <div
            className={
              "lg:hidden fixed top-0 left-0 w-screen h-16 bg-grey-5 z-50"
            }
          />
          <Logo className="main__logo" />
          <Drawer />
          <Switch>
            <Router />
          </Switch>
        </>
      )}
    </main>
  );
};

export default MainFlowApp;
